// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuestGuide_container__Dlkxq {
  padding-top: 140px;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #e0e0e0;
  position: relative;
  width: 100%;
  z-index: 2;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_back__G36-C {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #ead40c;
  cursor: pointer;
  display: flex;
  gap: 16px;
  margin-bottom: 78px;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_title__\\+4OiY {
  font-weight: 500;
  font-size: 36px;
  text-transform: uppercase;
  font-family: "DrukWideCyr_medium";
  line-height: 1.2em;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_title__\\+4OiY .QuestGuide_yellow__AXgJ8 {
  color: #ead40c;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt {
  line-height: 115%;
  margin-top: 45px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 100px;
  justify-content: space-between;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  width: 48%;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF img,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF .QuestGuide_obj_one__sVKox,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF .QuestGuide_obj_two__hLH90,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy .QuestGuide_obj_one__sVKox,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy .QuestGuide_obj_two__hLH90 {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF .QuestGuide_obj_one__sVKox .QuestGuide_title__\\+4OiY,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF .QuestGuide_obj_two__hLH90 .QuestGuide_title__\\+4OiY,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy .QuestGuide_obj_one__sVKox .QuestGuide_title__\\+4OiY,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy .QuestGuide_obj_two__hLH90 .QuestGuide_title__\\+4OiY {
  font-family: "HelveticaNeue";
  font-weight: 700;
  font-size: 24px;
  color: #e0e0e0;
  line-height: 1.2em;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF .QuestGuide_obj_one__sVKox .QuestGuide_desc__zcOFv,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF .QuestGuide_obj_two__hLH90 .QuestGuide_desc__zcOFv,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy .QuestGuide_obj_one__sVKox .QuestGuide_desc__zcOFv,
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy .QuestGuide_obj_two__hLH90 .QuestGuide_desc__zcOFv {
  font-family: "HelveticaNeue";
  font-weight: 400;
  font-size: 24px;
  color: #ffffff;
  line-height: 1.1em;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_banner__FBklC {
  display: none;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_btn__e112- {
  display: block;
  margin-top: 24px;
  display: flex;
  justify-content: center;
}
.QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_btn__e112- button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  background-color: #fd4c0a;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  width: 111px;
  height: 46px;
  padding: 0 22px;
  transition: background-color 0.3s;
}

@media (max-width: 850px) {
  .QuestGuide_container__Dlkxq {
    padding-top: 104px;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_backgroundImg__4kih\\+ {
    display: none;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft {
    width: 100%;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_back__G36-C {
    margin-bottom: 24px;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_title__\\+4OiY {
    font-size: 24px;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt {
    font-size: 16px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF,
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy {
    width: 100%;
    margin-bottom: 24px;
    flex-direction: column;
    align-items: baseline;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_one__6VYfF img,
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_info__jWSXt .QuestGuide_group_two__Ad\\+dy img {
    width: 80px;
    height: 80px;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_banner__FBklC {
    display: block;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_banner__FBklC img {
    width: 100%;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_btn__e112- {
    width: 111px;
    height: 46px;
  }
  .QuestGuide_container__Dlkxq .QuestGuide_wrapper__GQ1ft .QuestGuide_btn__e112- button {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/QuestGuide/QuestGuide.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGE;ECsCA,eAAA;EACA,gBAAA;EACA,kBAAA;EDrCE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAAJ;AAEI;ECoCF,eAAA;EACA,gBAAA;EACA,kBAAA;EDnCI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AACN;AAEI;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;AAAN;AAEM;EACE,cAAA;AAAR;AAII;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,8BAAA;AAFN;AAIM;;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;AAFR;AAIQ;;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AADV;AAIQ;;;;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;AAAV;AACU;;;;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAIZ;AAFU;;;;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAOZ;AADI;EACE,aAAA;AAGN;AAAI;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAEN;AAAM;EC5CJ,eAAA;EACA,gBAAA;EACA,kBAAA;ED6CM,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAGR;;AAQA;EACE;IACE,kBAAA;EALF;EAOE;IACE,aAAA;EALJ;EAQE;IACE,WAAA;EANJ;EAQI;IACE,mBAAA;EANN;EASI;IACE,eAAA;EAPN;EAUI;IACE,eAAA;IACA,WAAA;IACA,aAAA;IACA,sBAAA;IACA,QAAA;EARN;EAUM;;IAEE,WAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;EARR;EAUQ;;IACE,WAAA;IACA,YAAA;EAPV;EAYI;IACE,cAAA;EAVN;EAYM;IACE,WAAA;EAVR;EAaI;IACE,YAAA;IACA,YAAA;EAXN;EAYM;IACE,WAAA;IACA,uBAAA;EAVR;AACF","sourcesContent":["@import \"../../../assets/styles/global.scss\";\n\n.container {\n  padding-top: 140px;\n\n  .wrapper {\n    @include subtitle5;\n\n    color: #e0e0e0;\n    position: relative;\n    width: 100%;\n    z-index: 2;\n\n    .back {\n      @include subtitle6m;\n\n      align-items: center;\n      color: #ead40c;\n      cursor: pointer;\n      display: flex;\n      gap: 16px;\n      margin-bottom: 78px;\n    }\n\n    .title {\n      font-weight: 500;\n      font-size: 36px;\n      text-transform: uppercase;\n      font-family: \"DrukWideCyr_medium\";\n      line-height: 1.2em;\n\n      .yellow {\n        color: #ead40c;\n      }\n    }\n\n    .info {\n      line-height: 115%;\n      margin-top: 45px;\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      gap: 100px;\n      justify-content: space-between;\n\n      .group_one,\n      .group_two {\n        display: flex;\n        flex-direction: row;\n        gap: 15px;\n        align-items: center;\n        width: 48%;\n\n        img {\n          width: 100px;\n          height: 100px;\n          object-fit: cover;\n          border-radius: 8px;\n        }\n\n        .obj_one,\n        .obj_two {\n          display: flex;\n          flex-direction: column;\n          gap: 15px;\n          .title {\n            font-family: \"HelveticaNeue\";\n            font-weight: 700;\n            font-size: 24px;\n            color: #e0e0e0;\n            line-height: 1.2em;\n          }\n          .desc {\n            font-family: \"HelveticaNeue\";\n            font-weight: 400;\n            font-size: 24px;\n            color: #ffffff;\n            line-height: 1.1em;\n          }\n        }\n      }\n    }\n\n    .banner {\n      display: none;\n    }\n\n    .btn {\n      display: block;\n      margin-top: 24px;\n      display: flex;\n      justify-content: center;\n\n      button {\n        @include subtitle6m;\n\n        align-items: center;\n        background-color: #fd4c0a;\n        border-radius: 8px;\n        cursor: pointer;\n        display: flex;\n        gap: 8px;\n        width: 111px;\n        height: 46px;\n        padding: 0 22px;\n        transition: background-color 0.3s;\n        \n\n        // &:hover {\n        //   background-color: darken(#ead40c, 10%);\n        // }\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    padding-top: 104px;\n\n    .backgroundImg {\n      display: none;\n    }\n\n    .wrapper {\n      width: 100%;\n\n      .back {\n        margin-bottom: 24px;\n      }\n\n      .title {\n        font-size: 24px;\n      }\n\n      .info {\n        font-size: 16px;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n\n        .group_one,\n        .group_two {\n          width: 100%;\n          margin-bottom: 24px;\n          flex-direction: column;\n          align-items: baseline;\n\n          img {\n            width: 80px;\n            height: 80px;\n          }\n        }\n      }\n\n      .banner {\n        display: block;\n\n        img {\n          width: 100%;\n        }\n      }\n      .btn {\n        width: 111px;\n        height: 46px;\n        button {\n          width: 100%;\n          justify-content: center;\n        }\n      }\n    }\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuestGuide_container__Dlkxq`,
	"wrapper": `QuestGuide_wrapper__GQ1ft`,
	"back": `QuestGuide_back__G36-C`,
	"title": `QuestGuide_title__+4OiY`,
	"yellow": `QuestGuide_yellow__AXgJ8`,
	"info": `QuestGuide_info__jWSXt`,
	"group_one": `QuestGuide_group_one__6VYfF`,
	"group_two": `QuestGuide_group_two__Ad+dy`,
	"obj_one": `QuestGuide_obj_one__sVKox`,
	"obj_two": `QuestGuide_obj_two__hLH90`,
	"desc": `QuestGuide_desc__zcOFv`,
	"banner": `QuestGuide_banner__FBklC`,
	"btn": `QuestGuide_btn__e112-`,
	"backgroundImg": `QuestGuide_backgroundImg__4kih+`
};
export default ___CSS_LOADER_EXPORT___;
